module.exports = __webpack_public_path__ + "static/media/moon.e4f9a694.svg";